import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropDown } from '@/components/design-system/molecules/dropdown';
import { PaginatedColocApiConnectedDropDown } from '@/features/shared/feature-paginated-coloc-api-connected-dropdown';

import { House, Room } from '@/types/admin';
import { useGetHousesInfinite } from '@/features/shared/hooks/use-get-houses-infinite';
import { useGetRoomsInfinite } from '@/features/shared/hooks/use-get-rooms-infinite';
import { useCreateRentReportContext } from '../../../hooks/use-create-rent-report';

const SelectReportableDropdown: React.FC = () => {
  const { selectedReportableType, selectedHouse, selectedRoom, setSelectedHouse, setSelectedRoom, housesQuery, roomsQuery, setHousesQuery, setRoomsQuery } =
    useCreateRentReportContext()!;

  const { t } = useTranslation();

  if (selectedReportableType === 'Colocation') {
    const dataSource = useGetHousesInfinite({
      searchQuery: housesQuery,
    })

    return (
      <PaginatedColocApiConnectedDropDown<House>
        placeholder={
          t(
            'js.features.admin.transactions.transaction_pairing_modal.house_selection_placeholder'
          ) ?? ''
        }
        className="w-full"
        showLabel
        label={t(
          'js.features.admin.transactions.transaction_pairing_modal.house_selection_placeholder'
        )}
        value={selectedHouse}
        onChange={setSelectedHouse}
        {...(selectedHouse && {
          displayValue: selectedHouse.name,
        })}
        onTextInputChange={(event) => setHousesQuery(event.target.value)}
        dataSource={dataSource}
        itemRenderer={(itemProps, ref) => {
          return (
            // @ts-ignore
            <DropDown.DropDownOptionDefaultContent ref={ref}>
              {itemProps.name}
            </DropDown.DropDownOptionDefaultContent>
          );
        }}
      />
    );
  } else {
    const dataSource = useGetRoomsInfinite({
      searchQuery: roomsQuery,
    })

    return (
      <PaginatedColocApiConnectedDropDown<Room>
        placeholder={
          t(
            'js.features.admin.transactions.transaction_pairing_modal.room_selection_placeholder'
          ) ?? ''
        }
        className="w-full"
        showLabel
        label={t(
          'js.features.admin.transactions.transaction_pairing_modal.room_selection_placeholder'
        )}
        value={selectedRoom}
        onChange={setSelectedRoom}
        {...(selectedRoom && {
          displayValue: selectedRoom.name,
        })}
        onTextInputChange={(event) => setRoomsQuery(event.target.value)}
        dataSource={dataSource}
        itemRenderer={(itemProps, ref) => {
          return (
            // @ts-ignore
            <DropDown.DropDownOptionDefaultContent ref={ref}>
              {itemProps.name}
            </DropDown.DropDownOptionDefaultContent>
          );
        }}
      />
    );
  }
};

export { SelectReportableDropdown };
